import "./module/header"
import "./module/smooth"
import "./module/swiper"
import "./module/about-history"
import "./module/acc"

window.addEventListener("load", () => {
    let nowWidth = window.innerWidth >= 1024

    window.addEventListener("resize", () => {
        if (nowWidth != window.innerWidth >= 1024) {
            window.location.reload();
        }
    })
})